import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { flex, flexColumn } from "shared/theme/mixins";

export const StyledMessagesContainer = styled(Box)`
  ${flex({ fd: "column", jc: "start" })};
  row-gap: 1.5rem;
  padding: 1.5rem;
  padding-bottom: 0;
  flex-grow: 1;
  overflow-y: auto;
  flex: 1;
`;

export const StyledLoaderContainer = styled(Box)`
  ${flexColumn({ ai: "center", jc: "center" })};
  width: 100%;
  min-height: 80px;
`;

export const StyledLoader = styled(Box)`
  ${flexColumn({ ai: "center", jc: "center" })};
  width: 100%;
  min-height: 100%;
`;
